<template>
  <div>
    <h2><i>Tables</i></h2>
    <section>
      <div class="row">
        <div class="col-12"><b>Table 1:</b></div>
        <div class="col-12">Oligonucleotides used for Q-PCR</div>
        <div class="col-12"><div class="img h2"></div></div>
      </div>
    </section>

  <section>
    <div class="row">
      <div class="col-12"><b>Table 2:</b></div>
      <div class="col-12">Oligonucleotides used for Q-PCR</div>
    <div class="col-12"><div class="img h2"></div></div>
    </div>
  </section>

  </div>
</template>

<script>
  export default {
    name: 'interact',
    data () {
      return {
      }
    },
    created () {
      this.$parent.$parent.prevPage = {name: 'article-metrics'}
      this.$parent.$parent.nextPage = {name: 'article-media'}
      this.$parent.$parent.prevSlide = {name: 'article-interact'}
      this.$parent.$parent.nextSlide = {name: 'article-interact-figures'}
    }
  }
</script>


<style scoped lang="scss">
  .title {
    color: $primary-color;
    font-size: 32px;
  }
  section {
    margin: 20px auto;
    padding-bottom: 12px;
    &:not(:last-child) {
      border-bottom: 1px solid #cccccc;
    }
    .img {
      border: 1px solid #cccccc;
      background-color: #eeeeee;
      width: 100%;
      &.h1 {
        height: 160px;
      }
      &.h2 {
        height: calc(320px + 0.5rem);
      }
      &.h3 {
        height: calc(480px + 1rem);
      }
    }
  }

</style>



// WEBPACK FOOTER //
// InteractTablesPage.vue?8ed4dd94